export default __webpack_public_path__ + "static/media/image-loopstudios.46703ca6.jpg";